module.exports = __webpack_public_path__ + "static/media/careers.e455d885.jpg";